export const WIDGET_BASE_CONFIG = {
    limit: 6,
    showTitle: true,
    title: 'ข่าวสารและบทความ',
    showImage: true,
    showExcerpt: true,
    excerptLength: 120,
    showDate: true,
    dateFormat: 'relative',
    showAuthor: false,
    showCategory: true,
    showReadingTime: false,
    moreLabel: 'อ่านเพิ่มเติม',
    moreTarget: '_blank',
    showViewAllLink: true,
    viewAllLabel: 'ดูทั้งหมด',
    emptyText: 'ยังไม่มีบทความ',
    theme: {
        primary: '#1E63E9',
        text: '#0F172A',
        muted: '#64748B',
        bg: '#FFFFFF',
        cardBg: '#FFFFFF',
        border: '#E2E8F0',
        radius: 12,
        gap: 20,
        fontFamily: 'inherit',
        cardShadow: 'sm',
        imageRatio: '16/9',
    },
    darkMode: 'auto',
    customCss: '',
};
export const BASE_CONFIG_FIELDS = [
    { key: 'title', label: 'หัวข้อกล่อง', type: 'text', group: 'content' },
    { key: 'showTitle', label: 'แสดงหัวข้อกล่อง', type: 'boolean', group: 'content' },
    { key: 'limit', label: 'จำนวนบทความ', type: 'number', group: 'content', min: 1, max: 24 },
    { key: 'showImage', label: 'แสดงรูปภาพ', type: 'boolean', group: 'display' },
    { key: 'showExcerpt', label: 'แสดงคำโปรย', type: 'boolean', group: 'display' },
    { key: 'excerptLength', label: 'ความยาวคำโปรย', type: 'number', group: 'display', min: 40, max: 300 },
    { key: 'showDate', label: 'แสดงวันที่', type: 'boolean', group: 'display' },
    {
        key: 'dateFormat', label: 'รูปแบบวันที่', type: 'select', group: 'display',
        options: [
            { value: 'relative', label: 'เมื่อ 3 วันที่แล้ว' },
            { value: 'short', label: '20 ส.ค. 2569' },
            { value: 'long', label: '20 สิงหาคม 2569' },
        ],
    },
    { key: 'showAuthor', label: 'แสดงชื่อผู้เขียน', type: 'boolean', group: 'display' },
    { key: 'showCategory', label: 'แสดงหมวดหมู่', type: 'boolean', group: 'display' },
    { key: 'showReadingTime', label: 'แสดงเวลาอ่าน', type: 'boolean', group: 'display' },
    { key: 'moreLabel', label: 'ข้อความปุ่ม More info', type: 'text', group: 'content' },
    {
        key: 'moreTarget', label: 'เปิดลิงก์', type: 'select', group: 'content',
        options: [{ value: '_blank', label: 'แท็บใหม่' }, { value: '_self', label: 'แท็บเดิม' }],
    },
    { key: 'showViewAllLink', label: 'แสดงลิงก์ "ดูทั้งหมด"', type: 'boolean', group: 'content' },
    { key: 'viewAllLabel', label: 'ข้อความลิงก์ดูทั้งหมด', type: 'text', group: 'content' },
    { key: 'emptyText', label: 'ข้อความเมื่อไม่มีบทความ', type: 'text', group: 'content' },
    { key: 'theme.primary', label: 'สีหลัก', type: 'color', group: 'theme' },
    { key: 'theme.text', label: 'สีตัวอักษร', type: 'color', group: 'theme' },
    { key: 'theme.muted', label: 'สีตัวอักษรรอง', type: 'color', group: 'theme' },
    { key: 'theme.bg', label: 'สีพื้นหลัง', type: 'color', group: 'theme' },
    { key: 'theme.cardBg', label: 'สีพื้นการ์ด', type: 'color', group: 'theme' },
    { key: 'theme.border', label: 'สีเส้นขอบ', type: 'color', group: 'theme' },
    { key: 'theme.radius', label: 'ความมนของมุม (px)', type: 'number', group: 'theme', min: 0, max: 32 },
    { key: 'theme.gap', label: 'ระยะห่าง (px)', type: 'number', group: 'theme', min: 0, max: 64 },
    {
        key: 'theme.cardShadow', label: 'เงาการ์ด', type: 'select', group: 'theme',
        options: [
            { value: 'none', label: 'ไม่มี' }, { value: 'sm', label: 'บาง' },
            { value: 'md', label: 'กลาง' }, { value: 'lg', label: 'หนา' },
        ],
    },
    {
        key: 'theme.imageRatio', label: 'สัดส่วนรูป', type: 'select', group: 'theme',
        options: [
            { value: '16/9', label: '16:9' }, { value: '4/3', label: '4:3' },
            { value: '1/1', label: '1:1' }, { value: '3/2', label: '3:2' },
        ],
    },
    {
        key: 'darkMode', label: 'โหมดมืด', type: 'select', group: 'theme',
        options: [
            { value: 'auto', label: 'ตามเครื่องผู้ชม' },
            { value: 'light', label: 'สว่างเสมอ' },
            { value: 'dark', label: 'มืดเสมอ' },
        ],
    },
    {
        key: 'customCss', label: 'CSS เพิ่มเติม', type: 'textarea', group: 'advanced',
        help: 'ใส่ได้เฉพาะ CSS ธรรมดา — @import, url(javascript:) และ expression() จะถูกตัดทิ้งอัตโนมัติ',
    },
];
export const WIDGET_TEMPLATES = [
    {
        code: 'card-grid',
        name: 'Card Grid',
        description: 'การ์ด 2–4 คอลัมน์ มีรูปด้านบน + หัวข้อ + คำโปรย + ปุ่ม More info — เหมาะกับหน้าแรกเว็บบริษัททั่วไป',
        phase1: true, minPlan: 'FREE', sortOrder: 1,
        extraConfig: { columns: 3, columnsMobile: 1, cardStyle: 'elevated' },
        extraFields: [
            { key: 'columns', label: 'จำนวนคอลัมน์ (จอใหญ่)', type: 'number', group: 'display', min: 1, max: 4 },
            { key: 'columnsMobile', label: 'จำนวนคอลัมน์ (มือถือ)', type: 'number', group: 'display', min: 1, max: 2 },
            {
                key: 'cardStyle', label: 'สไตล์การ์ด', type: 'select', group: 'display',
                options: [
                    { value: 'elevated', label: 'มีเงา' },
                    { value: 'outlined', label: 'มีเส้นขอบ' },
                    { value: 'flat', label: 'เรียบ' },
                ],
            },
        ],
    },
    {
        code: 'list-compact',
        name: 'Compact List',
        description: 'รายการแนวตั้ง รูป thumbnail เล็กด้านซ้าย ข้อความด้านขวา — เหมาะกับ sidebar หรือพื้นที่แคบ',
        phase1: true, minPlan: 'FREE', sortOrder: 2,
        extraConfig: { thumbSize: 96, dividers: true },
        extraFields: [
            { key: 'thumbSize', label: 'ขนาดรูป (px)', type: 'number', group: 'display', min: 48, max: 160 },
            { key: 'dividers', label: 'แสดงเส้นคั่น', type: 'boolean', group: 'display' },
        ],
    },
    {
        code: 'slider',
        name: 'Carousel / Slider',
        description: 'เลื่อนแนวนอน มีลูกศรและจุดบอกตำแหน่ง เล่นอัตโนมัติได้ — โชว์บทความเยอะในพื้นที่จำกัด',
        phase1: true, minPlan: 'FREE', sortOrder: 3,
        extraConfig: { slidesPerView: 3, slidesPerViewMobile: 1, autoplay: false, autoplayDelay: 5000, loop: true, showArrows: true, showDots: true },
        extraFields: [
            { key: 'slidesPerView', label: 'จำนวนสไลด์ที่เห็น (จอใหญ่)', type: 'number', group: 'display', min: 1, max: 5 },
            { key: 'slidesPerViewMobile', label: 'จำนวนสไลด์ที่เห็น (มือถือ)', type: 'number', group: 'display', min: 1, max: 2 },
            { key: 'autoplay', label: 'เล่นอัตโนมัติ', type: 'boolean', group: 'display' },
            { key: 'autoplayDelay', label: 'หน่วงเวลา (ms)', type: 'number', group: 'display', min: 2000, max: 15000, step: 500 },
            { key: 'loop', label: 'วนกลับต้น', type: 'boolean', group: 'display' },
            { key: 'showArrows', label: 'แสดงลูกศร', type: 'boolean', group: 'display' },
            { key: 'showDots', label: 'แสดงจุดบอกตำแหน่ง', type: 'boolean', group: 'display' },
        ],
    },
    {
        code: 'minimal-text',
        name: 'Minimal Text',
        description: 'ไม่มีรูป — เฉพาะหัวข้อ + วันที่ + เส้นคั่น เหมาะกับเว็บสายทางการหรือหน้าประกาศ',
        phase1: true, minPlan: 'FREE', sortOrder: 4,
        extraConfig: { showBullet: true, numbered: false },
        extraFields: [
            { key: 'showBullet', label: 'แสดงจุดนำหน้า', type: 'boolean', group: 'display' },
            { key: 'numbered', label: 'ใส่ลำดับตัวเลข', type: 'boolean', group: 'display' },
        ],
    },
    {
        code: 'hero-feature',
        name: 'Featured Hero',
        description: 'บทความเด่น 1 อันใหญ่ด้านซ้าย + รายการเล็ก 3–4 อันด้านขวา — เหมาะกับหน้า Landing / ข่าวเด่น',
        phase1: true, minPlan: 'STARTER', sortOrder: 5,
        extraConfig: { sideCount: 4, heroPosition: 'left' },
        extraFields: [
            { key: 'sideCount', label: 'จำนวนรายการด้านข้าง', type: 'number', group: 'display', min: 2, max: 6 },
            {
                key: 'heroPosition', label: 'ตำแหน่งบทความเด่น', type: 'select', group: 'display',
                options: [{ value: 'left', label: 'ซ้าย' }, { value: 'right', label: 'ขวา' }],
            },
        ],
    },
    {
        code: 'masonry',
        name: 'Masonry Grid',
        description: 'Pinterest-style ความสูงการ์ดไม่เท่ากัน — เหมาะกับบล็อกสาย visual',
        phase1: true, minPlan: 'STARTER', sortOrder: 6,
        extraConfig: { columns: 3, columnsMobile: 1 },
        extraFields: [
            { key: 'columns', label: 'จำนวนคอลัมน์', type: 'number', group: 'display', min: 2, max: 4 },
            { key: 'columnsMobile', label: 'คอลัมน์บนมือถือ', type: 'number', group: 'display', min: 1, max: 2 },
        ],
    },
    {
        code: 'ticker',
        name: 'News Ticker',
        description: 'แถบข่าววิ่งแนวนอน 1 บรรทัด — เหมาะกับ header หรือ footer ของเว็บบริษัท',
        phase1: true, minPlan: 'STARTER', sortOrder: 7,
        extraConfig: { speed: 40, direction: 'left', pauseOnHover: true, prefixLabel: 'ข่าวล่าสุด' },
        extraFields: [
            { key: 'speed', label: 'ความเร็ว (px/วินาที)', type: 'number', group: 'display', min: 10, max: 200 },
            {
                key: 'direction', label: 'ทิศทาง', type: 'select', group: 'display',
                options: [{ value: 'left', label: 'ไปทางซ้าย' }, { value: 'right', label: 'ไปทางขวา' }],
            },
            { key: 'pauseOnHover', label: 'หยุดเมื่อชี้เมาส์', type: 'boolean', group: 'display' },
            { key: 'prefixLabel', label: 'ป้ายนำหน้า', type: 'text', group: 'content' },
        ],
    },
    {
        code: 'timeline',
        name: 'Timeline',
        description: 'เส้นเวลาแนวตั้ง มีจุด marker — เหมาะกับข่าวสารบริษัทหรือหน้าประวัติ',
        phase1: true, minPlan: 'STARTER', sortOrder: 8,
        extraConfig: { markerStyle: 'dot', side: 'left' },
        extraFields: [
            {
                key: 'markerStyle', label: 'รูปแบบ marker', type: 'select', group: 'display',
                options: [{ value: 'dot', label: 'จุด' }, { value: 'ring', label: 'วงแหวน' }, { value: 'square', label: 'สี่เหลี่ยม' }],
            },
            {
                key: 'side', label: 'ตำแหน่งเส้น', type: 'select', group: 'display',
                options: [{ value: 'left', label: 'ซ้าย' }, { value: 'center', label: 'กลาง' }],
            },
        ],
    },
    /*
     * ชุดที่เพิ่มทีหลัง — เขียน renderer จริงแล้วทั้งสามตัว จึงตั้ง phase1: true
     * sortOrder เริ่มที่ 9 ต่อจากของเดิม เพื่อให้ลำดับในหน้าเลือกไม่สลับของที่มีอยู่
     */
    {
        code: 'bento',
        name: 'Bento Grid',
        description: 'กริดไม่สมมาตรแบบกล่องข้าวญี่ปุ่น ชิ้นแรกใหญ่สุดแล้วไล่เล็กลง ข้อความทับบนรูป — ทันสมัย ใช้พื้นที่คุ้ม เหมาะกับหน้าแรก',
        phase1: true, minPlan: 'FREE', sortOrder: 9,
        extraConfig: {},
        extraFields: [],
    },
    {
        code: 'magazine',
        name: 'Magazine',
        description: 'ชิ้นเด่นเต็มความกว้าง ตัวอักษรใหญ่ทับบนรูป พร้อมรายการรองมีเลขอันดับ — ให้อารมณ์งานบรรณาธิการ เหมาะกับเว็บข่าวหรือ thought leadership',
        phase1: true, minPlan: 'STARTER', sortOrder: 10,
        extraConfig: { listPosition: 'side', showRank: true },
        extraFields: [
            {
                key: 'listPosition', label: 'ตำแหน่งรายการรอง', type: 'select', group: 'display',
                options: [{ value: 'side', label: 'ด้านข้าง' }, { value: 'below', label: 'ด้านล่าง' }],
            },
            { key: 'showRank', label: 'แสดงเลขอันดับ', type: 'boolean', group: 'display' },
        ],
    },
    {
        code: 'spotlight',
        name: 'Spotlight',
        description: 'การ์ดที่มีแสงวิ่งตามเมาส์และขอบเรืองแสงตามสีแบรนด์ — ดูล้ำแบบเว็บ SaaS สมัยใหม่ บนมือถือจะแสดงเป็นการ์ดปกติอัตโนมัติ',
        phase1: true, minPlan: 'PRO', sortOrder: 11,
        extraConfig: { columns: 3, columnsMobile: 1 },
        extraFields: [
            { key: 'columns', label: 'จำนวนคอลัมน์ (จอใหญ่)', type: 'number', group: 'display', min: 1, max: 4 },
            { key: 'columnsMobile', label: 'จำนวนคอลัมน์ (มือถือ)', type: 'number', group: 'display', min: 1, max: 2 },
        ],
    },
];
export const PHASE1_WIDGET_TEMPLATES = WIDGET_TEMPLATES.filter((t) => t.phase1).map((t) => t.code);
export function widgetTemplate(code) {
    return WIDGET_TEMPLATES.find((t) => t.code === code);
}
export function defaultWidgetConfig(code) {
    const tpl = widgetTemplate(code);
    return {
        ...structuredClone(WIDGET_BASE_CONFIG),
        ...(tpl ? structuredClone(tpl.extraConfig) : {}),
    };
}
export function widgetConfigFields(code) {
    const tpl = widgetTemplate(code);
    return [...BASE_CONFIG_FIELDS, ...(tpl?.extraFields ?? [])];
}
//# sourceMappingURL=widget-templates.js.map